import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import { SettingsPageFrame } from '@eluve/blocks';
import { Stack } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

import { BackfillEmrDataButton } from './BackfillEmrDataButton';
import {
  LocationsView,
  LocationsViewMode,
  LocationsViewToggle,
} from './LocationsTable';

export const LocationsPage: React.FC = () => {
  const { tenantId } = useParams() as { tenantId: string };
  const [view, setView] = useState<LocationsViewMode>('table');
  const { t } = useTranslation();

  return (
    <SettingsPageFrame
      size="wide"
      title={t('tenantAdmin.locations.title')}
      description={t('tenantAdmin.locations.description')}
      actions={
        <Stack direction="horizontal" gap={3} align="center" fullWidth={false}>
          <BackfillEmrDataButton tenantId={tenantId} />
          <LocationsViewToggle view={view} onViewChange={setView} />
        </Stack>
      }
    >
      <LocationsView tenantId={tenantId} view={view} />
    </SettingsPageFrame>
  );
};
